import React from "react";
import { CoverSlide } from "@/components/slides/CoverSlide";
import { MaturitySlide } from "@/components/slides/MaturitySlide";
import { CostSlide } from "@/components/slides/CostSlide";
import { ReframeSlide } from "@/components/slides/ReframeSlide";
import { ContextSlide } from "@/components/slides/ContextSlide";
import { AgentSlide } from "@/components/slides/AgentSlide";
import { PlaybackSlide } from "@/components/slides/PlaybackSlide";
import { ProofSlide } from "@/components/slides/ProofSlide";
import { FitSlide } from "@/components/slides/FitSlide";
import { HowSlide } from "@/components/slides/HowSlide";
import { CloseSlide } from "@/components/slides/CloseSlide";
import { PricingSlide } from "@/components/slides/PricingSlide";
import { SecuritySlide } from "@/components/slides/SecuritySlide";
import { FitAppendixSlide } from "@/components/slides/FitAppendixSlide";
import { AppendixSlide } from "@/components/slides/AppendixSlide";
import { PlaceholderSlide } from "@/components/slides/PlaceholderSlide";

// Single source of truth for which component renders each slide index.
export const SlideView = ({ manifest, isAppendix, index, aIndex, demoCall, onDemoCall }) => {
  const slides = manifest?.slides || [];
  const appendix = manifest?.appendix || [];
  const noop = onDemoCall || (() => {});

  if (isAppendix) {
    if (aIndex === 0) return <PricingSlide />;
    if (aIndex === 1) return <SecuritySlide />;
    if (aIndex === 2) return <FitAppendixSlide />;
    return <AppendixSlide slide={appendix[aIndex]} />;
  }

  switch (index) {
    case 0:
      return <CoverSlide data={manifest} />;
    case 1:
      return <MaturitySlide slide={slides[1]} />;
    case 2:
      return <CostSlide slide={slides[2]} />;
    case 3:
      return <ReframeSlide slide={slides[3]} />;
    case 4:
      return <ContextSlide slide={slides[4]} />;
    case 5:
      return <AgentSlide slide={slides[5]} onDemoCall={noop} />;
    case 6:
      return <PlaybackSlide slide={slides[6]} demoCall={demoCall} />;
    case 7:
      return <ProofSlide slide={slides[7]} />;
    case 8:
      return <FitSlide slide={slides[8]} />;
    case 9:
      return <HowSlide slide={slides[9]} />;
    case 10:
      return <CloseSlide slide={slides[10]} />;
    default:
      return <PlaceholderSlide slide={slides[index]} />;
  }
};

export default SlideView;
